/**
 * Table de correspondance nom de compositeur (tel que dans works) → prénom.
 * Utilisée pour l'autofill du champ « Prénom du compositeur » quand parseComposerToGivenAndFamily
 * ne trouve pas d'espace (ex. "Dvořák" → "Antonín").
 * Orthographe et accents vérifiés (forme usuelle francophone / internationale).
 */
export const COMPOSER_GIVEN_NAMES = {
  Adams: 'John',
  Adès: 'Thomas',
  Albinoni: 'Tomaso',
  Albéniz: 'Isaac',
  Antheil: 'George',
  Arnold: 'Malcolm',
  Babbitt: 'Milton',
  Bach: 'Johann Sebastian',
  Balakirev: 'Mily',
  Barber: 'Samuel',
  Bartók: 'Béla',
  Bax: 'Arnold',
  Beethoven: 'Ludwig van',
  Bellini: 'Vincenzo',
  Berg: 'Alban',
  Berio: 'Luciano',
  Berlioz: 'Hector',
  Bernstein: 'Leonard',
  Berwald: 'Franz',
  Biber: 'Heinrich',
  Birtwistle: 'Harrison',
  Bizet: 'Georges',
  Bloch: 'Ernest',
  Boccherini: 'Luigi',
  Borodin: 'Alexander',
  Boulez: 'Pierre',
  Brahms: 'Johannes',
  Britten: 'Benjamin',
  Bruch: 'Max',
  Bruckner: 'Anton',
  Busoni: 'Ferruccio',
  Buxtehude: 'Dieterich',
  Byrd: 'William',
  Cage: 'John',
  Carter: 'Elliott',
  Chabrier: 'Emmanuel',
  Charpentier: 'Marc-Antoine',
  Chausson: 'Ernest',
  Cherubini: 'Luigi',
  Chopin: 'Frédéric',
  Chávez: 'Carlos',
  Copland: 'Aaron',
  Corelli: 'Arcangelo',
  Corigliano: 'John',
  Couperin: 'François',
  Crumb: 'George',
  Cui: 'César',
  Daugherty: 'Michael',
  Debussy: 'Claude',
  Delibes: 'Léo',
  Delius: 'Frederick',
  Dittersdorf: 'Carl Ditters von',
  Dohnányi: 'Ernő',
  Donizetti: 'Gaetano',
  Dowland: 'John',
  Dufay: 'Guillaume',
  Dukas: 'Paul',
  Duruflé: 'Maurice',
  Dutilleux: 'Henri',
  Dvořák: 'Antonín',
  Elgar: 'Edward',
  Enescu: 'George',
  Falla: 'Manuel de',
  Fauré: 'Gabriel',
  Field: 'John',
  Franck: 'César',
  Frescobaldi: 'Girolamo',
  Gershwin: 'George',
  Gesualdo: 'Carlo',
  Gibbons: 'Orlando',
  Ginastera: 'Alberto',
  Glass: 'Philip',
  Glazunov: 'Alexander',
  Glinka: 'Mikhail',
  Glière: 'Reinhold',
  Gluck: 'Christoph Willibald',
  Goldmark: 'Karl',
  Gomes: 'Carlos',
  Gould: 'Morton',
  Gounod: 'Charles',
  Grainger: 'Percy',
  Granados: 'Enrique',
  Grieg: 'Edvard',
  Gubaidulina: 'Sofia',
  Górecki: 'Henryk',
  Handel: 'George Frideric',
  Hanson: 'Howard',
  Harris: 'Roy',
  Haydn: 'Joseph',
  Henze: 'Hans Werner',
  Herbert: 'Victor',
  Hindemith: 'Paul',
  Holmboe: 'Vagn',
  Holst: 'Gustav',
  Honegger: 'Arthur',
  Hummel: 'Johann Nepomuk',
  Humperdinck: 'Engelbert',
  Ibert: 'Jacques',
  Ives: 'Charles',
  Janacek: 'Leoš',
  Janequin: 'Clément',
  Joplin: 'Scott',
  Kabalevsky: 'Dmitry',
  Khachaturian: 'Aram',
  Kodály: 'Zoltán',
  Korngold: 'Erich Wolfgang',
  Lalo: 'Édouard',
  Lassus: 'Orlande',
  Leoncavallo: 'Ruggero',
  Ligeti: 'György',
  Liszt: 'Franz',
  'Lopes-Graça': 'Fernando',
  Lully: 'Jean-Baptiste',
  Lutoslawski: 'Witold',
  Léonin: '',
  MacDowell: 'Edward',
  Machaut: 'Guillaume de',
  Mahler: 'Gustav',
  Marais: 'Marin',
  Marcello: 'Benedetto',
  Martinů: 'Bohuslav',
  Mascagni: 'Pietro',
  Massenet: 'Jules',
  Mendelssohn: 'Felix',
  Messiaen: 'Olivier',
  Mignone: 'Francisco',
  Milhaud: 'Darius',
  Moeran: 'E. J.',
  Monteverdi: 'Claudio',
  Mozart: 'Wolfgang Amadeus',
  Mussorgsky: 'Modest',
  Nielsen: 'Carl',
  Nono: 'Luigi',
  Obrecht: 'Jacob',
  Ockeghem: 'Johannes',
  Offenbach: 'Jacques',
  Orff: 'Carl',
  Pachelbel: 'Johann',
  Paganini: 'Niccolò',
  Palestrina: 'Giovanni Pierluigi da',
  Pärt: 'Arvo',
  Penderecki: 'Krzysztof',
  Pergolesi: 'Giovanni Battista',
  Piazzolla: 'Astor',
  Poulenc: 'Francis',
  Praetorius: 'Michael',
  Prokofiev: 'Sergei',
  Puccini: 'Giacomo',
  Purcell: 'Henry',
  Rachmaninoff: 'Sergei',
  Rameau: 'Jean-Philippe',
  Rautavaara: 'Einojuhani',
  Ravel: 'Maurice',
  Reger: 'Max',
  Reich: 'Steve',
  Respighi: 'Ottorino',
  Rihm: 'Wolfgang',
  'Rimsky-Korsakov': 'Nikolai',
  Rodrigo: 'Joaquín',
  Rorem: 'Ned',
  Rossini: 'Gioachino',
  Roussel: 'Albert',
  'Saint-Saëns': 'Camille',
  Salieri: 'Antonio',
  Satie: 'Erik',
  Scarlatti: 'Domenico',
  Schmidt: 'Franz',
  Schnittke: 'Alfred',
  Schoenberg: 'Arnold',
  Schubert: 'Franz',
  Schuman: 'William',
  Schumann: 'Robert',
  Schütz: 'Heinrich',
  Scriabin: 'Alexander',
  Shostakovich: 'Dmitri',
  Sibelius: 'Jean',
  Smetana: 'Bedřich',
  Sor: 'Fernando',
  Spohr: 'Louis',
  Stamitz: 'Johann',
  Stenhammar: 'Wilhelm',
  Stockhausen: 'Karlheinz',
  Strauss: 'Richard',
  Stravinsky: 'Igor',
  Suk: 'Josef',
  Sweelinck: 'Jan Pieterszoon',
  Szymanowski: 'Karol',
  Takemitsu: 'Tōru',
  Tallis: 'Thomas',
  Tartini: 'Giuseppe',
  Taverner: 'John',
  Tchaikovsky: 'Pyotr Ilyich',
  Telemann: 'Georg Philipp',
  Tippett: 'Michael',
  Varèse: 'Edgard',
  Verdi: 'Giuseppe',
  Victoria: 'Tomás Luis de',
  'Villa-Lobos': 'Heitor',
  Vivaldi: 'Antonio',
  Wagner: 'Richard',
  Walton: 'William',
  Weber: 'Carl Maria von',
  Webern: 'Anton',
  Weill: 'Kurt',
  Widor: 'Charles-Marie',
  Wolf: 'Hugo',
  Xenakis: 'Iannis',
  Ysaÿe: 'Eugène',
  Zemlinsky: 'Alexander von',
  "d'Indy": 'Vincent',
}

/**
 * Retourne le prénom du compositeur si connu (pour autofill), sinon ''.
 * La clé doit correspondre exactement à composerName dans works (accents inclus).
 * @param {string} composerName - Nom du compositeur tel que dans works (ex. "Dvořák", "Janacek")
 * @returns {string}
 */
export function getComposerGivenName(composerName) {
  if (!composerName || typeof composerName !== 'string') return ''
  const trimmed = composerName.trim()
  return COMPOSER_GIVEN_NAMES[trimmed] ?? ''
}
